import { Radio, Zap, Users, GitBranch, ArrowRight } from "lucide-react";

const TONE = {
  trigger: { color: "text-atlas-red", ring: "border-atlas-red/50 bg-atlas-red/10", dot: "#FF2A2A", Icon: Radio },
  grid: { color: "text-amber-300", ring: "border-amber-400/40 bg-amber-400/[0.06]", dot: "#FBBF24", Icon: Zap },
  population: { color: "text-sky-300", ring: "border-sky-400/40 bg-sky-400/[0.06]", dot: "#38BDF8", Icon: Users },
  secondary: { color: "text-atlas-orange", ring: "border-atlas-orange/40 bg-atlas-orange/[0.06]", dot: "#FF9500", Icon: ArrowRight },
};

// Compound-risk chain: primary trigger → one secondary hazard (capped at two links), drawn as a
// connected vertical timeline. Every node traces back to the mapped exposure.
export const CascadeChain = ({ cascade, testId }) => {
  if (!cascade || !Array.isArray(cascade.nodes)) return null;
  // max two links: primary trigger → one triggered secondary
  const nodes = [cascade.nodes.find((n) => n.tone === "trigger"), cascade.nodes.find((n) => n.tone === "secondary")].filter(Boolean);
  if (nodes.length <= 1) return null;
  return (
    <div className="mb-4 border border-white/10 bg-white/[0.02] p-3" data-testid={testId}>
      <div className="flex items-center gap-1.5 mb-2.5">
        <GitBranch className="w-3.5 h-3.5 text-atlas-cyan" />
        <span className="text-[10px] uppercase tracking-widest text-atlas-cyan/70 font-mono">
          Cascade · Compound-Risk Chain
        </span>
      </div>
      <div className="relative pl-1">
        {nodes.map((n, i) => {
          const tone = TONE[n.tone] || TONE.trigger;
          const last = i === nodes.length - 1;
          return (
            <div key={i} className="relative flex gap-2.5 pb-3 last:pb-0" data-testid={`cascade-node-${i}`}>
              {!last && (
                <span
                  className="absolute left-[7px] top-4 bottom-0 w-px"
                  style={{ background: "linear-gradient(to bottom, rgba(255,255,255,0.25), rgba(255,255,255,0.05))" }}
                />
              )}
              <span
                className="relative z-10 mt-0.5 w-3.5 h-3.5 rounded-full border-2 shrink-0"
                style={{ borderColor: tone.dot, background: "#0D1117" }}
              />
              <div className={`min-w-0 flex-1 border-l-2 ${tone.ring} pl-2.5 py-1.5 pr-2 -mt-0.5`}>
                <div className="flex items-center justify-between gap-2">
                  <span className={`text-[11px] font-display leading-tight ${tone.color} flex items-center gap-1.5`}>
                    <tone.Icon className="w-3 h-3 shrink-0" />
                    {n.title}
                  </span>
                  {n.metric && <span className={`text-[10px] font-mono shrink-0 ${tone.color}`}>{n.metric}</span>}
                </div>
                {n.detail && <p className="text-[10px] text-atlas-secondary leading-relaxed mt-0.5">{n.detail}</p>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
